<template>
  <div class="AutoThreewaySwitch" :class="[directionClass, widgetClass]">
    <div @click="switchClicked($event)" class="SingleSwitchGeneral lxn-cursor-pointer" :class="disabledClass">
      <div class="SingleSwitchGeneral-switch lxn-w100 lxn-h100 lxn-pos-rel" :class="switchClass">
        <div class="SingleSwitchGeneral-switchOval lxn-h100" :style="ovalStyle"></div>
        <div class="SingleSwitchGeneral-switchCircle lxn-pos-abs" :style="circleStyle"></div>
      </div>
    </div>
    <div class="timerBtn">
      <div v-html="btnIcon" @click="timereClicked($event)" :class="iconClass"></div>
    </div>
  </div>
</template>

<script>
import svgIcons from '@/statics/svgIcons.js';
export default {
  name: "AutoThreewaySwitch",
  props: {
    state: String,
    widgeetMode: String,
    bgColorOn: String,
    bgColorOff: String,
    handleColorOn: String,
    handleColorOff: String,
    disabled: Boolean,
  },
  components: {},
  data: function () {
    return {};
  },
  computed: {
    _widgeetMode: function () {
      if (this.widgeetMode === undefined){
        return "manual";
      }
      else{
        return this.widgeetMode;
      }
    },
    switchClass: function () {
      if (this.state == "off") {
        return "";
      } else if (this.state == "pending") {
        return "middle";
      } else if (this.state == "on") {
        return "on";
      } else {
        return "";
      }
    },
    ovalStyle: function () {
      var ovalStyle = "";
      if (this._widgeetMode == "auto"){
        // ovalStyle += "border: 0 solid rgb(150,150,150);";
        // ovalStyle += "background-color: " + this.bgColorOff + ";";
        if (this.state == "on" ) {
          ovalStyle += "background-color: rgb(0, 174, 239);";
        } else if (this.state == "off") {
          ovalStyle += "border: 0 solid rgb(150,150,150);";
          ovalStyle += "background-color: " + this.bgColorOff + ";";
        }
      }
      else if (this.state == "on" ) {
        ovalStyle += "border: 15px solid " + this.bgColorOn + ";";
        ovalStyle += "background-color: " + this.bgColorOff + ";";
      } else if (this.state == "off") {
        ovalStyle += "border: 0 solid rgb(150,150,150);";
        ovalStyle += "background-color: " + this.bgColorOff + ";";
      }
      return ovalStyle;
    },
    circleStyle: function () {
      var circleStyle = "";
      if (this._widgeetMode == "auto") {
        circleStyle = "background-color: " + this.handleColorOff + ";";
        // circleStyle += "right:left;";
        if (this.state == "on") {
          circleStyle += "right:2px;left:none;";
        }
      }else if (this.state == "on") {
        circleStyle = "background-color: " + this.handleColorOn + ";";
        circleStyle += "right:2px;left:none;";
      } else if (this.state == "off") {
        circleStyle = "background-color: " + this.handleColorOff + ";";
      }
      return circleStyle;
    },
    widgetClass: function () {
      var circleStyle = "";
      if (this._widgeetMode == "auto") {
        return "auto";
        // circleStyle += "right:left;";
      }else {
        return ""
      }
    },
    iconClass: function () {
      if (this._widgeetMode == "auto") {
        return "auto ";
      } else {
        return "manual";
      }
    },
    disabledClass: function () {
      return this.disabled ? "disabled" : "";
    },
    btnIcon: function (){
      return svgIcons["timer"];
    },
    directionClass: function (){
      return this.$store.getters.language.texts.isRTL ? "rtl" : "ltr"
    }
  },
  methods: {
    switchClicked: function ($event) {
      if (!this.disabled) {
        this.$emit("switchClicked", $event);
      }
    },
    timereClicked: function ($event) {
      if (!this.disabled) {
        this.$emit("timerClicked", $event);
      }
    },
  },
};
</script>

<style >
/* :root {
  --text-color: {{ this.bgColorOn }};
  --bg-color: {{ bgColor }};
} */
.AutoThreewaySwitch .timerBtn {
  width: 2rem;
  height: 30px;
  display: inline-block;
  vertical-align: middle;
}
.AutoThreewaySwitch{
  border-radius: 50px;
  padding: 4px;
  border: 0 solid rgb(150,150,150);
  background-color: rgb(150,150,150);
}


.AutoThreewaySwitch.rtl {
  direction: rtl;
}
.AutoThreewaySwitch.ltr {
  direction: ltr;
}
.AutoThreewaySwitch.rtl .timerBtn {
  margin-right: 16px;
}
.AutoThreewaySwitch.ltr .timerBtn {
  margin-left: 16px;
}
.AutoThreewaySwitch.auto {
  border-radius: 50px;
  /* border: 0 solid rgb(150,150,150);
  background-color: rgb(150,150,150); */
  border: 0 solid rgb(0, 137, 189) ;
  background-color: rgb(0, 137, 189) ;
  padding: 4px;

}
.AutoThreewaySwitch .SingleSwitchGeneral {
  width: calc(100% - 2rem - 16px); /* 16px is to compensate margin-left/right */
  height: 30px;
  display: inline-block;
  vertical-align: middle;
}

.SingleSwitchGeneral.disabled {
  opacity: 0.4;
}
.SingleSwitchGeneral-switchCircle {
  left: 2px;
  top: 2px;
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  border-radius: 50%;
  /* box-shadow: 0 1px 3px rgba(0,0,0,0.4); */
  /* border: 1px solid rgb(150,150,150); */
  transition: all 0.2s linear;
}
.SingleSwitchGeneral-switchOval {
  border-radius: 50px;
  box-sizing: border-box;
  -webkit-transition: border 0.3s;
  -webkit-transition-timing-function: linear;
  transition: border 0.3s;
  transition-timing-function: linear;
}
.AutoThreewaySwitch .timerBtn .auto .icon{
  color: #FFF ;
  /* color: rgb(0, 174, 239) ; */
}
.AutoThreewaySwitch .timerBtn .manual .icon{
  color: rgb(172, 184, 191);
}


.row {
  display: flex;
  flex-direction: row;
}

.col-8 {
  width: 80%;
}

.light-icon {
  width: 40px;
  height: 40px;
  margin: 4px 12px 12px 12px;
}

.active .ButtonIcon {
  background: #0a8dc6 !important;
  fill: #fff !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .SingleSwitchGeneral-switchCircle {
  height: 16px !important;
  width: 16px !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .SingleSwitchGeneral-switchOval {
  height: 20px !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .timerBtn {
  height: 20px !important;
  margin-right: 3px !important;
  width: auto !important;
  vertical-align: top !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .AutoThreewaySwitch {
  height: 28px !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .timerBtn .icon {
  height: 20px !important;
}

.AddNewWidget-wrapper-threeway-switch.sm-switch .AutoThreewaySwitch .SingleSwitchGeneral {
  height: 25px !important;
  width: calc(100% - 2rem - 0px) !important;
}
</style>
